export const feedContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
};

export const emptyStateStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
  padding: '48px 24px',
  textAlign: 'center',
};
